module.exports = __webpack_public_path__ + "img/home-06.175781e0.png";